export const environment = {
  production: false,
  envName: 'dev',
  apiUrl: 'https://dev-api.bizzweaver.com'
};
